export default function PreviewCarousel({ pieces }) {
  if (!pieces?.length) return null;

  return (
    <section className="preview-carousel" aria-label="Miniaturas de los recortes">
      {pieces.map((p, i) => (
        <img key={i} src={p} alt={`Recorte ${i + 1}`} />
      ))}
    </section>
  );
}
